import { useNavigate } from "react-router-dom";
import {
  PRESS_RELEASE_LIST_ROUTE,
  PRESS_RELEASE_ADD_ROUTE,
} from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { X } from "lucide-react";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "../../Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import ImageData from "Common/Components/customImage/Image";
import { JOB_LIST_ROUTE, JOB_ADD_ROUTE } from "constants/routeEnum";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";

const Addjob = () => {
  const navigate = useNavigate();
  const [jobField, setJobField] = useState<any>();
  const [imageLink, setImageLink] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [content, setContent] = useState<any>("");
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const [locationList, setLocationList] = useState<any>([]);
  const [divisionList, setDivisionList] = useState<any>([]);
  const [experienceList, setExperienceList] = useState<any>([]);
  const [staticExperience, setStaticExperience] = useState<any>();
  const [staticLocation, setStaticLocation] = useState<any>();
  const [staticDivision, setStaticDivision] = useState<any>();
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please select Image", "error");
      }
    }
  }, [imageData]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  useEffect(() => {
    const fetchDataByCode = async (code: string) => {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        return res.data.content?.params || [];
      }
      return [];
    };
    const fetchAllData = async () => {
      let results = await Promise.all([
        fetchDataByCode("job-division"),
        fetchDataByCode("job-experience"),
        fetchDataByCode("job-location"),
      ]);
      if (results.length > 0) {
        setExperienceList(results[1]);
        setLocationList(results[2]);
        setDivisionList(results[0]);
      }
    };

    fetchAllData();
  }, []);

  const handleChangeJob = (name, value) => {
    if (name === "experience") {
      setStaticExperience(value);
    } else if (name === "division") {
      setStaticDivision(value);
    } else if (name === "location") {
      setStaticLocation(value);
    }
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      description: "",

      // location: "",
      link: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      // description: Yup.string().required("Please enter description"),

      // location: Yup.string().required("Please enter location"),
      // link: Yup.string().required("Please enter link"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!staticDivision?.value) {
        showNotification("Please select division", "error");
        return;
      } else if (!staticExperience?.value) {
        showNotification("Please select experience", "error");
        return;
      } else if (!staticLocation?.value) {
        showNotification("Please select location", "error");
        return;
      }
      try {
        setLoader(true);
        const res = await callApi(`v1/job/new`, "post", {
          job: {
            name: values?.name,
            location: staticLocation?.value,
            division: staticDivision?.value,
            experience: staticExperience?.value,
            description: values?.description,
            link: values?.link,
            page_title: " ",
            url: " ",
            meta_description: " ",
            meta_keyword: " ",
            canonical_url: " ",
          },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Job created successfully", "success");
          setLoader(true);
          setTimeout(() => {
            navigate(JOB_LIST_ROUTE);
            setLoader(false);
          }, 1000);
        }
      }  catch (e) {
        showNotification(e?.message || "Something went wrong", "error");
      } finally {
        setLoader(false); 
      }
    },
  });
  return (
    <>
      <BreadCrumb
        title={JOB_ADD_ROUTE}
        pageTitle={JOB_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Job Name"
                    name="name"
                    onChange={validation.handleChange}
                    value={validation.values.name || ""}
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <p className="text-red-400">{validation.errors.name}</p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Location
                  </label>

                  <ReactSelect
                    options={locationList}
                    contentType={staticLocation}
                    name={"location"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                  />
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Experience
                  </label>

                  <ReactSelect
                    options={experienceList}
                    contentType={staticExperience}
                    name={"experience"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                  />
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Division
                  </label>

                  <ReactSelect
                    options={divisionList}
                    contentType={staticDivision}
                    name={"division"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                  />
                </div>
                <div className="xl:col-span-12" style={{display: "none"}}>
                  <label
                    htmlFor="employeeInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Description
                  </label>
                  <textarea
                    data-type="text"
                    rows={4}
                    id="employeeInput"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Description"
                    name="description"
                    onChange={validation.handleChange}
                    value={validation.values.description || ""}
                  />
                  {validation.touched.description &&
                  validation.errors.description ? (
                    <p className="text-red-400">
                      {validation.errors.description}
                    </p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="emailInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Link
                  </label>
                  <input
                    type="text"
                    id="emailInput"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Link "
                    name="link"
                    onChange={validation.handleChange}
                    value={validation.values.link || ""}
                  />
                  {validation.touched.link && validation.errors.link ? (
                    <p className="text-red-400">{validation.errors.link}</p>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(JOB_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  id="addNew"
                  disabled={loader}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Add Jobs"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default Addjob;
